// src/components/about/TeamMemberCard.js
import React from 'react';
import AnimateOnScroll from './AnimateOnScroll'; // Adjust path as needed

// Placeholder icons (replace with actual imports or SVGs)
const linkedInOrange = "https://firebasestorage.googleapis.com/v0/b/plasticanalytics-ada31.appspot.com/o/landingPage%2Ficons%2Flinkedin-orange.webp?alt=media&token=6fcfbc59-8bf4-4817-8c9f-80c3fd369e07";
const message = "https://firebasestorage.googleapis.com/v0/b/plasticanalytics-ada31.appspot.com/o/landingPage%2Ficons%2Fmessage.webp?alt=media&token=dcf0b9b4-7496-45c3-91e6-0865d2dde0be";
const reseachGate = "https://firebasestorage.googleapis.com/v0/b/plasticanalytics-ada31.appspot.com/o/landingPage%2Ficons%2FresearchGate.webp?alt=media&token=c0620f6d-f099-4f25-8584-da6a1b15acfe";

const TeamMemberCard = ({ member, delay = 0 }) => {
  const { name, title, affiliations, description, imageSrc, links } = member;

  return (
    // Apply animation with optional delay for staggering effect
    <AnimateOnScroll delay={delay}>
      <div>
        <img
          src={imageSrc}
          alt={name}
          style={{
            width: '100%',
            height: 'auto', // Maintain aspect ratio
            borderRadius: '4px',
            marginBottom: '20px',
            display: 'block',
          }}
        />
        <h3 style={{ fontSize: '1.3rem', marginBottom: '5px', fontWeight: 'normal' }}>
          {name}
        </h3>
        {/* Social Links */}
        <div style={{ display: 'flex', gap: '15px', marginBottom: '10px', alignItems: 'center' }}>
          {links?.linkedIn && <a href={links.linkedIn} target="_blank" rel="noopener noreferrer"><img src={linkedInOrange} alt="LinkedIn" style={{ width: '20px', height: '20px' }}/></a>}
          {links?.email && <a href={`mailto:${links.email}`}><img src={message} alt="Email" style={{ width: '20px', height: '20px' }}/></a>}
          {links?.researchGate && <a href={links.researchGate} target="_blank" rel="noopener noreferrer"><img src={reseachGate} alt="ResearchGate" style={{ width: '20px', height: '20px' }}/></a>}
          {/* Add other links like Twitter similarly */}
           {links?.twitter && <a href={links.twitter} target="_blank" rel="noopener noreferrer"><img src={linkedInOrange} alt="Twitter" style={{ width: '20px', height: '20px' }}/></a>} {/* Assuming same icon for twitter*/}
        </div>
        {/* Title/Affiliation */}
        <p style={{ fontSize: '0.9rem', margin: '0 0 5px 0', color: '#6b7280' }}>
          {title}
        </p>
        {affiliations?.map((line, index) => (
           <p key={index} style={{ fontSize: '0.9rem', margin: '0 0 5px 0', color: '#6b7280' }}>
             {line}
           </p>
        ))}
         <p style={{ fontSize: '0.9rem', margin: '0 0 15px 0', color: '#6b7280' }}>
              Imperial College London {/* Example if affiliation is constant */}
          </p>
        {/* Description */}
        <p style={{ fontSize: '0.9rem', lineHeight: '1.6', color: '#4b5563' }}>
          {description}
        </p>
      </div>
    </AnimateOnScroll>
  );
};

export default TeamMemberCard;